import { render, staticRenderFns } from "./LiveUpList.vue?vue&type=template&id=e923542a&"
import script from "./LiveUpList.vue?vue&type=script&lang=js&"
export * from "./LiveUpList.vue?vue&type=script&lang=js&"
import style0 from "./LiveUpList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports